import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  EventEmitter,
  inject,
  input,
  Input,
  InputSignal,
  OnChanges,
  OnInit,
  Output,
  signal,
  Signal,
  SimpleChanges,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { initOnLoad } from 'apexcharts';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexYAxis,
} from 'ng-apexcharts';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { ReportDataService } from '../../../../services';
export type ChartOptionsLine = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  grid: ApexGrid;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
};
import { NgApexchartsModule } from 'ng-apexcharts';
import { TranslatePipe } from '@ngx-translate/core';
import {
  Results,
  TotalNumberOfSubmittedClaims,
} from '../../../../interfaces/reports/total-number-of-submitted-claims';
import {
  BaseDashboardChartComponent,
  FilterOption,
} from '../../base-dashboard-chart.component';
import { SelectModule } from 'primeng/select';
import { SpinnerComponent } from '../../../spinner/spinner.component';
import { ChartCardComponent } from '../../chart-card/chart-card.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';


type FilterModel = 'All' | string[] | number[];
@Component({
  selector: 'co-line-chart',
  standalone: true,
  imports: [NgApexchartsModule, TranslatePipe, FormsModule, ChartCardComponent, SelectModule, TableModule, SpinnerComponent],
  templateUrl: './line-chart.component.html',
  styleUrl: './line-chart.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineChartComponent
  extends BaseDashboardChartComponent
  implements OnInit {
  readonly chartCase = input<string>('');

  @ViewChild('chart') chart?: ChartComponent;
  private langChangeSub?: Subscription;

  public chartOptions!: Partial<ChartOptionsLine> | any;
  data = input.required<TotalNumberOfSubmittedClaims>();
  chartReady = input.required<boolean>();

  testResults = computed(() => this.data().testResults);
  chartData = computed(() => this.data().chartData);
  tableData = computed(() => this.data().tableData ?? []);

  seriesData = computed(() => {
    return this.chartData().map(group => ({
      name: group.group,
      data: Array.isArray(group.data) ? group.data.map(d => d.count) : [],
    }));
  });

  categories = computed(() => {
    return this.chartData()
      .flatMap(group => Array.isArray(group.data) ? group.data.map(d => d.monthYear) : []);
  });
  constructor(private translate: TranslateService) {
    super();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.updateChartOptions();
    });
    effect(() => {
      if (this.chartData()) {
        this.updateChartOptions();
      }
    });
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }
  ngOnInit() {
  }
  override onDropdownChange(): void {
    this.onFilterChange.emit(this.selectedFilters);
  }

  private updateChartOptions() {
    const labels = this.categories();


    this.chartOptions = {
      series: this.seriesData(),
      chart: {
        height: 350,
        type: 'line',
        zoom: { enabled: false },
        toolbar: {
          show: true,
          tools: { download: true, zoom: true, zoomin: false, zoomout: false, pan: false, reset: true },
        },
      },
      dataLabels: { enabled: false },
      stroke: { curve: 'straight' },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: this.categories(),
        type: 'category',
        title: {
          text: this.translate.instant('LINE_CHART.ADMISSION_DATE'),
          style: {
            fontWeight: 'bold',
            fontSize: '14px',
            color: '#263238',
          },
        },
      },
      yaxis: {
        show: true,
        title: {
          text: this.translate.instant('LINE_CHART.NUMBER_OF_CLAIMS'),
        },
      },
      tooltip: {
        x: {
          formatter: (val: string, opts: any) =>
            labels[opts.dataPointIndex] || val,
        },
      },
    };
  }
}

